import { gql } from 'apollo-angular';

export const RemoveVoucherFragment = gql`
  fragment RemoveVoucher on OrderOutput {
    id
    dateTimeToLive
    screeningItems {
      id
      seatId
      screeningId
      ticketId
      seat
      row
      price
      voucherNumber
      name
      printoutName
    }
  }
`;
